import React, { useState, useEffect } from 'react';
import { api } from '../api';
import { css } from './UI';

// Direcciones de entrega de las órdenes de compra (catálogo en Requisiciones ›
// Direcciones de Entrega). El selector devuelve { id, texto }: id de una dirección
// del catálogo, u OTRA con el domicilio escrito a mano para entregas excepcionales.
export const OTRA = 'otra';

export function useDireccionesEntrega() {
  const [direcciones, setDirecciones] = useState(null);
  useEffect(() => { api.get('/direcciones-entrega').then(setDirecciones).catch(() => setDirecciones([])); }, []);
  return direcciones;
}

// Valor inicial: la dirección ligada a la sucursal de la requisición, si hay una
export const entregaInicial = (direcciones, sucursal) => {
  const d = (direcciones || []).find(x => x.sucursal && x.sucursal === sucursal);
  return { id: d ? d._id : '', texto: '' };
};

// Valor de una orden ya emitida (para editarla)
export const entregaDeOrden = (orden, direcciones) => {
  const id = orden.direccionEntregaId && (direcciones || []).some(d => d._id === String(orden.direccionEntregaId)) ? String(orden.direccionEntregaId) : '';
  if (id) return { id, texto: '' };
  return orden.direccionEntrega ? { id: OTRA, texto: orden.direccionEntrega } : { id: '', texto: '' };
};

// Cuerpo para la API
export const entregaParaApi = (v) => (v.id && v.id !== OTRA ? { direccionEntregaId: v.id } : { direccionEntregaId: '', direccionEntrega: v.texto });
export const entregaValida = (v) => Boolean(v.id && (v.id !== OTRA || v.texto.trim()));

export function SelectorEntrega({ value, onChange, direcciones, sucursal }) {
  const elegida = (direcciones || []).find(d => d._id === value.id);
  const etiqueta = { fontSize: 11, fontWeight: 700, color: 'var(--glass)', textTransform: 'uppercase', marginBottom: 5 };
  return (
    <div>
      <div style={etiqueta}>Dirección de entrega <span style={{ color: 'var(--danger)' }}>*</span></div>
      <select value={value.id} onChange={e => onChange({ id: e.target.value, texto: e.target.value === OTRA ? value.texto : '' })} style={css.select(!entregaValida(value))}>
        <option value="">{direcciones === null ? 'Cargando…' : 'Elige la dirección…'}</option>
        {(direcciones || []).map(d => <option key={d._id} value={d._id}>{d.nombre}{d.sucursal && d.sucursal === sucursal ? ' (sucursal de la requisición)' : ''}</option>)}
        <option value={OTRA}>Otra dirección (escribirla)…</option>
      </select>
      {elegida && (
        <div style={{ fontSize: 12, color: 'var(--ink-soft)', marginTop: 6, lineHeight: 1.5 }}>
          {elegida.domicilio}
          {(elegida.horario || elegida.contacto || elegida.telefono) && (
            <div style={{ color: 'var(--glass)' }}>{[elegida.horario && `Horario: ${elegida.horario}`, [elegida.contacto, elegida.telefono].filter(Boolean).join(' · ') && `Recibe: ${[elegida.contacto, elegida.telefono].filter(Boolean).join(' · ')}`].filter(Boolean).join(' — ')}</div>
          )}
        </div>
      )}
      {value.id === OTRA && (
        <>
          <textarea value={value.texto} onChange={e => onChange({ id: OTRA, texto: e.target.value })} rows={2} autoFocus
            placeholder="Domicilio completo, horario y quién recibe. Ej. ESFUERZO 7-A, INDUSTRIAL ATOTO, CP 53519, NAUCALPAN; L-V 8:00-17:00"
            style={{ ...css.input(!value.texto.trim()), resize: 'vertical', marginTop: 6 }} />
          <div style={{ fontSize: 11, color: 'var(--glass)', marginTop: 4 }}>Queda marcada como fuera de catálogo. Si se va a repetir, pide que la den de alta en Direcciones de Entrega.</div>
        </>
      )}
      {direcciones?.length === 0 && value.id !== OTRA && (
        <div style={{ fontSize: 11, color: 'var(--glass)', marginTop: 4 }}>Todavía no hay direcciones en el catálogo: el admin o el jefe de compras las dan de alta en Requisiciones › Direcciones de Entrega.</div>
      )}
    </div>
  );
}
